import React from 'react'
import Swal from 'sweetalert2'

export const Alert = ({
  icon,
  title,
  text,
  showCancelButton,
  showConfirmButton,
  showLoaderOnConfirm,
  cancelButtonText,
  confirmButtonText,
  confirmButtonColor,
  confirmed,
  failText,
  successText,
  cancelText
}) => {
  return (
    Swal.fire({
      icon,
      title,
      text,
      showCancelButton,
      showConfirmButton,
      showLoaderOnConfirm,
      cancelButtonText,
      confirmButtonText,
      confirmButtonColor,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await confirmed()
          .then((response) => {
            console.log(response)
            Swal.fire(successText, "", "success").then(
              (result) => {
                if (result.isConfirmed) {
                  // window.location.reload();
                }
              }
            );
          })
          .catch((err) => {
            Swal.fire(err.toString(), "", "error");
          });
      } else {
        Swal.fire(cancelText, "", "info");
      }
    })
  )
}

export const AlertNotif = ({
  icon,
  title,
  html
}) => {
  return (
    Swal.fire({
      icon,
      title,
      html
    })
  )
}

export const validateAlert = ({
  icon,
  title,
  text,
  confirmed,
  confirmButtonText
}) => {
  return (
    Swal.fire({
      title,
      text,
      icon,
      // showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText
    }).then((result) => {
      if (result.isConfirmed) {
        confirmed()
      }
    })
  )
}